import React, { useEffect, useState } from "react";
import './styles.css'
import { IoMdAlarm, IoIosArrowForward } from "react-icons/io";
import { PaperAdd } from "solar-icon-set/notes";
import { Colors } from "../../../utils/constants/colors";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAxios } from "../../../hooks/useAxios";
import SpinnerLoader from "../../../components/loader";
import { ApiCollection, MERCHANT_KEY, MERCHANT_SALT, udf1, PAYU_BASE_URL, envConfig } from "../../../config/envConfig";
import { formatRelative } from 'date-fns'
import SubjectHeader from "../../../components/subjectHeader";
import { FaLock } from "react-icons/fa";
import { Subject } from "../../../utils/interface/subject";
import { PaymentData } from "../../../utils/interface/payment";
import Modal from "../../../components/modal";
import { useUser } from "../../../redux/useStore";
import { toast } from 'react-toastify';
import { offers } from "../../../utils/constants/offers";
import { Tag } from "solar-icon-set/money";
import { CheckCircle } from "solar-icon-set/essentionalui";
import { logEvent } from '../../../utils/analytics/analytics';
import CryptoJS from 'crypto-js';
import AnalysisPoster from '../../../assets/analysisPoster.svg'



export default function SubjectViewScreen() {

    const [searchParams] = useSearchParams()

    const subjectId = searchParams.get('subjectId');
    const user = useUser();


    useEffect(() => {
        if(subjectId){
            getDetails();
            fetchSubjects()
        }else{
            navigate('/')
        }
       
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchSubjects = async () => {
        setIsLoading(true);
        await axios.get(ApiCollection.subject.getList)
            .then((response) => {
                setSubjects(response.data.subject);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching subjects:', error);
                setIsLoading(false);
            })

    };





    const axios = useAxios();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showCheckout, setShowCheckout] = useState<Boolean>(false);
    const [avialableTests, setAvialableTests] = useState([]);
    const [pastTests, setPastTests] = useState([]);
    const [couponText, setCouponText] = useState<string>('');
    const [couponDiscount, setCouponDiscount] = useState<number>(0);
    const [isCouponLoading, setIsCouponLoading] = useState<boolean>(false);
    const [subjects, setSubjects] = useState<Subject[]>([]);
    const [selectedSubjects, setSelectedSubjects] = useState<Subject[]>([]);
    const [isValidating, setIsValidating] = useState<boolean>(false);


    const availableSubjects = subjects.filter(sub => (sub.price > 0 && sub.is_unlocked === false));

    const gradedTests = pastTests.filter((test: any) => test.is_completed === true);
    const pendingTests = pastTests.filter((test: any) => test.is_completed === false);

    const getDetails = async () => {
        setIsLoading(true);
        await axios.get(`${ApiCollection.subject.getDetails}?subject=${subjectId}`)
            .then((response) => {
                console.log(response.data);
                const tests = response.data.test_type;
                setAvialableTests(tests);

                const pastTests = response.data.previous_attempt_data;
                setPastTests(pastTests);

                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching subjects:', error);
                setIsLoading(false);
            });
    }

    const getCheckoutPricing = () => {
        let cartValue = selectedSubjects.reduce((a, b) => a + b.price, 0);
        let offer = offers.find(off => off.minimumCartQuantity === selectedSubjects.length) || null;
        let discount = offer ? offer.discount : 0;

        let data = {
            discountAmount: discount,
            withDiscount: (cartValue - discount),
            payable: (cartValue - discount),
            cartValue: cartValue,
            offer,
            couponDiscount,
        };

        if (couponDiscount > 0) {
            data.payable = Number((data.withDiscount - (data.withDiscount * (couponDiscount / 100))).toFixed(2));
            data.couponDiscount = Number((data.withDiscount * (couponDiscount / 100)).toFixed(2));
        }

        if (data.payable <= 0) {
            data.payable = 0;
            data.withDiscount = 0;
            data.discountAmount = 0;
            data.cartValue = 0;
            data.offer = null;
            data.couponDiscount = 0;
        }

        return data;
    };

    const onCouponApply = async () => {
        setIsCouponLoading(true);
        try {
            const response = await axios.get(`${ApiCollection.user.applyCoupon}${couponText}/`);
            if (response.data.status) {
                const discountPercentage = parseFloat(response.data.discount);
                setCouponDiscount(discountPercentage);
                toast.success(response.data.message, { position: "top-right" });
            } else {
                toast.error(response.data.message, { position: "top-right" });
                setCouponDiscount(0);
            }
        } catch (error) {
            console.error('Error applying coupon:', error);
            toast.error('Error applying coupon', { position: "top-right" });
            setCouponDiscount(0);
        } finally {
            setIsCouponLoading(false);
        }
    };



    const onHandleTestClick = async (test: any) => {
        if (test.is_unlocked) {
            if (test.test_type === "MOCK_TEST") {
                setIsLoading(true);
                await axios.post(ApiCollection.subject.generateQuestionPaper, {
                    subject: subjectId,
                    test_type: test.test_id,
                    chapter: []
                })
                    .then((response) => {
                        setIsLoading(false);
                        navigate(`/test/instructions?examId=${response.data.exam_id}&title=${test.test_name}`);
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        console.error('Error generating question paper:', error.response);
                    });
            } else {
                navigate(`/subject/chapters?subjectId=${subjectId}&testId=${test.test_id}&title=${test.test_name}`);
            }
        } else {
            // console.log(test)
            logEvent('Test', 'Locked Test Click', '', {
                test_id: test.test_id,
                test_name: test.test_name,
                test_type: test.test_type,
                total_marks: test.total_marks
            });
            
            const thisSubject = availableSubjects.find(sub => sub.id === subjectId);
            if (thisSubject) {
                setSelectedSubjects([thisSubject])
            }
            setShowCheckout(true);
        }
    }


    const onSubjectClick = (subject: Subject) => {
        const thisSubject = selectedSubjects.find(sub => sub.id === subject.id);
        if (thisSubject) {
          logEvent('Subject', 'Remove from Cart', '', {
            subject_id: subject.id,
            subject_parent_id: subject.parent_id,
            subject_title: subject.subject,
            action_type: 'remove'
          });
          setSelectedSubjects(selectedSubjects.filter(sub => sub.id !== subject.id));
        } else {
          logEvent('Subject', 'Added to Cart', '', {
            subject_id: subject.id,
            subject_parent_id: subject.parent_id,
            subject_title: subject.subject,
            action_type: 'Add'
          });
          setSelectedSubjects([...selectedSubjects, subject]);
        }
      };
      

    const handleCheckout = async () => {
        try {
            setIsValidating(true);
            const selectedIds = selectedSubjects.map(subject => subject.parent_id);

            try {
                const validationResponse = await axios.post(ApiCollection.subject.validateLockedSubject, {
                    parent_id: selectedIds
                });

                if (!validationResponse.data.status) {
                    toast.error('Some subjects are not available for purchase.', {
                        position: "top-right"
                    });
                    return;
                }
            } catch (error: any) {
                toast.error(error.response.data.detail, {
                    position: "top-right"
                });
                return;
            } finally {
                setIsValidating(false);
            }


            const checkoutProperties = {
                subscription_plan: `Multiple Subjects (${selectedSubjects.length})`,
                purchase_amount: getCheckoutPricing().payable,
                selected_subject_ids: selectedIds,
                selected_subject_titles: selectedSubjects.map(s => s.subject),
                selected_subject_count: selectedSubjects.length
            };

            logEvent('Purchase', 'Checkout Attempt', '', checkoutProperties);

            if (!MERCHANT_KEY) {
                throw new Error('MERCHANT_KEY is not configured');
            }

            let basePaymentData: PaymentData = {
                key: MERCHANT_KEY,
                txnid: `txn_${Date.now()}`,
                amount: getCheckoutPricing().payable,
                productinfo: `Multiple Subjects (${selectedSubjects.length})`,
                firstname: user?.firstName || "",
                email: user?.email || "",
                phone: user?.mobileNo || "",
                surl: `${ApiCollection.payment.logSuccess}`,
                furl: `${ApiCollection.payment.logFailure}`,
                udf2: selectedIds.join(','),
            };

            if (envConfig.isProd) {
                basePaymentData.service_provider = "payu_paisa"
                basePaymentData.udf1 = udf1
            } else {
                // basePaymentData.pg = "TESTPG"
                // basePaymentData.bankcode = "TESTPGNB"
                basePaymentData.service_provider = "payu_paisa"
                basePaymentData.udf1 = udf1
            }

            const data = basePaymentData
            const hashString = `${MERCHANT_KEY || ''}|${data.txnid}|${data.amount}|${data.productinfo}|${data.firstname}|${data.email}|${data.udf1}|${data.udf2}|||||||||${MERCHANT_SALT}`;
            data.hash = CryptoJS.SHA512(hashString).toString();


            const form = document.createElement('form');
            form.method = 'post';
            if (!PAYU_BASE_URL) {
                throw new Error('PAYU_BASE_URL is not configured');
            }
            form.action = PAYU_BASE_URL;

            for (const [key, value] of Object.entries(data)) {
                if (value !== undefined) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value.toString();
                    form.appendChild(input);
                }
            }

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);



        } catch (error: any) {
            console.error('Error during checkout:', error);
            toast.error(error.response.data.detail, {
                position: "top-right"
            });
        }
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Loading...
                </h2>
            </div>
        )

    }



    return (
        <div className="subject_view_screen">

            <div className="avialable_tests">
                <div className="subject_view_wrapper">

                    <SubjectHeader
                        title="Practice Now"
                        description="Start practicing with our AI generated exams. You can also customize your exam by selecting specific chapters !"
                    />

                    <div className="test_holder">
                        {avialableTests.length &&
                            avialableTests.map((test: any) => (
                                <div className="test_card main" onClick={() => onHandleTestClick(test)}>
                                    {
                                        test.is_unlocked ?
                                            test.test_type === "MOCK_TEST" ?
                                                <PaperAdd size={30} color={Colors.primary} /> :
                                                <IoMdAlarm className="test_icon" size={30} />
                                            :
                                            <FaLock size={22} style={{ marginRight: 10 }} color={Colors.primary} />
                                    }

                                    <span className="test_name main">{test.test_name}</span>
                                    <p>Max marks - {test.total_marks}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

            </div>



            {
                gradedTests.length > 0 ?
                    <div className="past_tests graded">
                        <div className="subject_view_wrapper">
                            <h3 className="new_heading">Graded Tests</h3>
                            <p className="heading_desc">
                                Your Test Analysis will appear here. You can also review the test and see the correct answers.
                            </p>


                            <div className="past_test_holder">
                                {
                                    gradedTests.map((test: any) => (
                                        <div className="past_test_card" onClick={() => navigate(`/test/analysis?examId=${test.exam_id}&title=${test.name}&subjectId=${subjectId}`)}>
                                            <div className="test_info">
                                                <h3 className="test_name">{test.name}</h3>
                                                <p className="test_desc">{formatRelative(new Date(test.started_at), new Date())}</p>
                                                <p className="test_desc">Chapters - {test.chapters.map((te: any, index: number) => `${te.title} ${index === test.chapters.length - 1 ? '' : ','}`)} </p>
                                            </div>
                                            {
                                                (test.score !== null && test.total_marks) ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 15 }}>
                                                            <span className="score_text">{test.score}/{test.total_marks}</span>
                                                            <span style={{ fontSize: 14, color: 'gray' }}>Marks</span>
                                                        </div>
                                                        <IoIosArrowForward size={28} color={Colors.primary} />
                                                    </div>
                                                    :
                                                    <IoIosArrowForward size={28} color={Colors.primary} />
                                            }

                                        </div>

                                    ))
                                }
                            </div>

                        </div>
                    </div>
                    :
                    <div className="past_tests">
                        <div className="subject_view_wrapper">
                            <h3 className="new_heading" >Graded Tests</h3>
                            <div className="analysis_poster_holder">

                                <img
                                    src={AnalysisPoster}
                                    alt="Analysis Poster"
                                    className="analysis_poster"
                                />
                                <p className="poster_desc">
                                    Your Test Analysis will appear here. Start practicing with our AI generated exams now and unlock your potential.
                                </p>

                            </div>


                        </div>

                    </div>
            }

            {
                pendingTests.length > 0 &&
                <div className="past_tests">
                    <div className="subject_view_wrapper">
                        <h3 className="new_heading">Pending Tests</h3>
                        <p className="heading_desc">
                            You have some tests pending to be completed. Finish them and check your results.
                        </p>


                        <div className="past_test_holder">
                            {
                                pendingTests.map((test: any) => (
                                    <div className="past_test_card" onClick={() => navigate(`/test/view?examId=${test.exam_id}&title=${test.name}`)}>
                                        <div className="test_info">
                                            <h3 className="test_name">{test.name}</h3>
                                            <p className="test_desc">{formatRelative(new Date(test.started_at), new Date())}</p>
                                            <p className="test_desc">Chapters - {test.chapters.map((te: any, index: number) => `${te.title} ${index === test.chapters.length - 1 ? '' : ','}`)} </p>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>

                                            <IoIosArrowForward size={28} />
                                        </div>
                                    </div>

                                ))
                            }
                        </div>
                    </div>

                </div>

            }


            {showCheckout && (
                <Modal
                    onClose={() => {
                        setShowCheckout(false);
                        setSelectedSubjects([]);
                    }}
                >
                    <div className="plans_holder">
                        <div className="plans_holder_head">
                            <h2 className="modal_heading">🚀 Boost Your Learning Journey!</h2>
                            <span className="modal_description">Unlock any subject(s) of your choice and enhance your learning experience.</span>
                        </div>
                        <div className="checkout_holder">
                            <div className="subject_holder">
                                <div className="sub_selector">
                                    <h3>Available Subject(s)</h3>
                                    <div className="sub_holder">
                                        {availableSubjects.map((subject) => (
                                            <div
                                                key={subject.id}
                                                className={`sub_chip ${selectedSubjects.find(sub => sub.id === subject.id) ? 'selected' : ''}`}
                                                onClick={() => onSubjectClick(subject)}
                                            >
                                                {subject.subject}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="offer_holder">
                                    {selectedSubjects.length > 0 && (
                                        <div className="offer_holder coupon_section">
                                            <h3 style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: 16 }}>Enter Coupon Code</h3>
                                            <div className="coupon_input">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Coupon Code"
                                                    value={couponText}
                                                    onChange={(e) => setCouponText(e.target.value)}
                                                />
                                                <button
                                                    onClick={onCouponApply}
                                                    disabled={couponText.length === 0 || isCouponLoading}
                                                    className="primary_btn coupon_apply"
                                                >
                                                    {isCouponLoading ? (
                                                        <div className="button-loader"></div>
                                                    ) : (
                                                        'Apply'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    <h3 style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: 16 }}>Offers</h3>
                                    {offers.map((offer) => (
                                        <div key={offer.id} className={`offer_card ${getCheckoutPricing().offer?.id === offer.id ? 'active' : ''}`}>
                                            {getCheckoutPricing().offer?.id === offer.id ? (
                                                <CheckCircle size={18} color={Colors.success} iconStyle='Bold' />
                                            ) : (
                                                <Tag size={18} color={Colors.primary} iconStyle='Bold' />
                                            )}
                                            <span>{offer.title}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="checkout_summary">
                                <h3>Order Summary</h3>
                                <div className="order_holder">
                                    <div className="order_item_list">
                                        {selectedSubjects.length > 0 ? (
                                            selectedSubjects.map((subject) => (
                                                <div className="order_item" key={subject.id}>
                                                    <span className="item_name">1x {subject.subject}</span>
                                                    <span className="item_price">Rs. {subject.price || 0}</span>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="order_item">
                                                <span>Select any subject</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="order_checkout_section">
                                        {getCheckoutPricing().discountAmount > 0 && (
                                            <div className="order_item discount">
                                                <span>Offer Discount</span>
                                                <span>- Rs. {getCheckoutPricing().discountAmount}</span>
                                            </div>
                                        )}

                                        {getCheckoutPricing().couponDiscount > 0 && couponText.length > 0 && (
                                            <div className="order_item discount">
                                                <span>Coupon Discount</span>
                                                <span>- Rs. {getCheckoutPricing().couponDiscount}</span>
                                            </div>
                                        )}

                                        <div className="order_item">
                                            <span>Total</span>
                                            <span>Rs. {getCheckoutPricing().payable}</span>
                                        </div>
                                        <button
                                            style={{ width: '100%' }}
                                            className="primary_btn"
                                            onClick={handleCheckout}
                                            disabled={selectedSubjects.length === 0 || getCheckoutPricing().payable <= 0 || isValidating}
                                        >
                                            {isValidating ? (
                                                <div className="button-loader"></div>
                                            ) : (
                                                'Proceed To Checkout'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}

        </div>
    )
}